var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg"},[_c(_vm.componentName,{tag:"component",attrs:{"data1":_vm.supplyMainData,"data":_vm.data,"disabled":_vm.disabled},on:{"Topage":_vm.ToSecondPage,"backToMain":_vm.back}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }